import { ApiError, errorMessage } from '../api/client';

interface Props {
  error: unknown;
  title?: string;
  onRetry?: () => void;
}

export function ErrorMessage({ error, title = 'Das hat nicht geklappt', onRetry }: Props) {
  const requestId = error instanceof ApiError ? error.requestId : undefined;
  return (
    <div className="alert alert-error error-message" role="alert">
      <strong>{title}</strong>
      <p>{errorMessage(error)}</p>
      <div className="error-actions">
        {onRetry && (
          <button type="button" className="btn" onClick={onRetry}>
            Erneut versuchen
          </button>
        )}
        {requestId && <small className="muted">Referenz: {requestId}</small>}
      </div>
    </div>
  );
}
